import type { ICartLine } from '~/modules/cart/types/cart-types';
import type { IOrderLine } from '~/modules/checkout/types/orders';

export default ({ offer_id, quantity, product_id, id }: ICartLine): IOrderLine => ({
  cart_line_id: `${id}`,
});
